import { DAYPARTS } from 'helpers/consts';
import { IntlShape } from 'react-intl';

export function getLanguageName(langCode: string, displayLocale = 'en') {
  const displayNames = new Intl.DisplayNames([displayLocale], {
    type: 'language',
  });
  return displayNames.of(langCode);
}

export function getWeekdays(
  locale: string = 'en-US',
  format: 'long' | 'short' | 'narrow' = 'long',
) {
  const formatter = new Intl.DateTimeFormat(locale, { weekday: format });
  // Create a dummy date for each day of the week (starting on Sunday)
  const weekdays = [];
  const baseDate = new Date(Date.UTC(1966, 1, 6)); // Sunday, 'arbitrary' week
  for (let i = 0; i < 7; i++) {
    const date = new Date(baseDate);
    date.setDate(baseDate.getDate() + i);
    weekdays.push(formatter.format(date));
  }

  return weekdays;
}

type DayPart = {
  key: string;
  hour: number;
  name?: string;
};
export function getDayParts(intl?: IntlShape): DayPart[] {
  return Object.entries(DAYPARTS).map(([key, value]) => ({
    key: key,
    hour: value,
    name: intl
      ? intl.formatMessage({ id: `USERS.NOTIFICATIONS.PARTOFDAY.${key}` })
      : undefined,
  }));
}
